import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSelectPageList } from '@/api/ListParam';
export default {
  data: function data() {
    return {
      localData: this.bindData,
      // 分页表格配置
      dropdownFormData: {
        Key: '',
        PARAM_NAME: '',
        Page: 1,
        Limit: 15
      },
      dropdownLoading: false,
      dropdownSelect: false,
      dropdownTotalPage: 0,
      dropdownData: []
    };
  },
  props: {
    // 字段名称
    paramName: {
      type: String,
      required: true
    },
    bindData: {
      type: [String, Array]
    },
    title: {
      type: String,
      default: '信息'
    },
    params: {
      type: Object
    },
    requestData: {
      type: Function,
      default: GetSelectPageList
    }
  },
  watch: {
    bindData: {
      handler: function handler(val) {
        this.localData = val;
      }
    }
  },
  methods: {
    CellClick: function CellClick(_ref) {
      var row = _ref.row;
      this.localData = row.CODE;
      console.log(row);
      this.$emit('MesTableData', row);
      this.$refs.xDown.hidePanel();
    },
    handleClear: function handleClear() {
      this.$emit('MesTableData', {
        CODE: ''
      });
    },
    handleKeyupEvent: function handleKeyupEvent(Key) {
      console.log(Key);
      this.dropdownFormData.Key = Key;
      this.GetSelectPageList();
    },
    handleDropFocus: function handleDropFocus() {
      this.dropdownFormData.PARAM_NAME = this.paramName;
      this.GetSelectPageList();
      this.$refs.xDown.showPanel();
    },
    // 根据字段获取下拉数据
    GetSelectPageList: function GetSelectPageList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var formData, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dropdownLoading = true;
                formData = Object.assign(_this.dropdownFormData, _this.params);
                _context.next = 4;
                return _this.requestData(formData).catch(function (_) {
                  _this.dropdownLoading = false;
                });

              case 4:
                res = _context.sent;
                _this.dropdownLoading = false;

                if (res.Result) {
                  _this.dropdownData = res.Result || [];
                  _this.dropdownTotalPage = res.TotalCount;
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 自定义排序
    customSortMethod: function customSortMethod(_ref2) {
      var column = _ref2.column,
          property = _ref2.property,
          order = _ref2.order;
      var obj = {};

      if (order === 'asc') {
        obj.OrderBySort = 0;
      } else {
        obj.OrderBySort = 1;
      }

      var OrderBySort = obj.OrderBySort;
      this.dropdownFormData.OrderByParam = property;
      this.dropdownFormData.OrderBySort = OrderBySort;
      this.GetSelectPageList();
    },
    handleSizeChange: function handleSizeChange(Limit) {
      this.dropdownFormData.Limit = Limit;
      this.GetSelectPageList();
    },
    handleCurrentChange: function handleCurrentChange(Page) {
      this.dropdownFormData.Page = Page;
      this.GetSelectPageList();
    }
  }
};